import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ArrowDownCappedIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M6 20H18" />
      <path d="M16 12L12 16L8 12" />
      <path d="M12 4V16" />
    </SvgIcon>
  )
}
